import { Box, Button, LinearProgress, List } from "@mui/material";
import {
  API_URL,
  BootstrapTooltip,
  ConvertToMiladiDateDB,
} from "../../utilities";
import PageTitle from "../../components/PageTitle";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";

import PopoverComponent from "../../components/PopoverComponent";

import SkeltonProgress from "../../components/SkeltonProgress";
import { IService } from "src/interface/IService";
import NewTransaction from "./new-transaction";
import { getRoutes } from "src/utilities/routes";
import {
  ListofTransactionType,
  TransactionType,
} from "src/interface/enum/TransactionType";
import { TypeUser } from "src/interface/enum/TypeUser";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
import { IAppUser } from "src/interface/IUser";
import {
  renderDate,
  renderDateEditInputCell,
} from "./components/date-picker/DatePickerEditInputCell";
import { useLocation } from "react-router-dom";
import { ITransaction } from "src/interface/ITransaction";
import ImportExcelButton from "./components/import-excel/import-button";
const Transactions = ({ userId }: { userId?: string }) => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const Routes = getRoutes();
  const location = useLocation();
  const pathName = "/transactions";
  const [rows, setRows] = useState<ITransaction[]>([]);

  const { mutate: getTransactions, isPending: isTransactionLoading } =
    useMutation({
      mutationFn: async () => {
        const response = await fetch(Routes.TransactionRoutes, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user?.token}`,
            Aceept: "application/json",
          },
        });
        return await response.json();
      },
      onSuccess: (responseData: ITransaction[]) => {
        if (responseData && responseData.length > 0) {
          setRows(responseData.filter((item) => item.transactionStatus === 1));
        }
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log(error);
      },
    });

  const {
    mutate: getTransactionsByUserId,
    isPending: isTransactionByUserIdLoading,
  } = useMutation({
    mutationFn: async (id: string) => {
      const response = await fetch(Routes.TransactionRoutes + "user/" + id, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData: ITransaction[]) => {
      if (responseData && responseData.length > 0) {
        setRows(responseData.filter((item) => item.transactionStatus === 1));
      }
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });
  const [openTask, setOpenTask] = useState<boolean>(false);

  useEffect(() => {
    if (user?.token) {
      GetListCustomers();
      if (pathName === location.pathname) {
        getTransactions();
      } else if (userId) {
        getTransactionsByUserId(userId);
      }
    }
  }, [user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.TransactionRoutes + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(Routes.TransactionRoutes + bankId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const [getCustomers, setGetCustomers] = useState<IAutoCompleteLabelValue[]>(
    []
  );
  const { mutateAsync: GetListCustomers, isPending: isCustomersLoading } =
    useMutation({
      mutationFn: async () => {
        const response = await fetch(
          Routes.UsersRoutes + "getByRole/" + TypeUser.CUSTOMER,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${user?.token}`,
              Aceept: "application/json",
            },
          }
        );
        return await response.json();
      },
      onSuccess: (responseData: IAppUser[]) => {
        if (responseData && responseData.length > 0) {
          setGetCustomers(
            responseData.map((item: IAppUser) => ({
              label: item.fName + " " + item.lName + " " + item.coName,
              value: item.id,
              item: item,
            }))
          );
        }
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log(error);
      },
    });

  const columns: GridColDef<ITransaction>[] = [
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={<SaveIcon color="success" />}
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                //disabled={params.row.transactionType !== TransactionType.Manual}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }

        return [
          <BootstrapTooltip title="ویرایش">
            <GridActionsCellItem
              icon={<EditIcon color="primary" />}
              label="ویرایش"
              // disabled={params.row.transactionType !== TransactionType.Manual}
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={
                <DeleteIcon
                  color={
                    params.row.transactionType === TransactionType.Systemic
                      ? "disabled"
                      : "error"
                  }
                />
              }
              label="حذف"
              disabled={params.row.transactionType === TransactionType.Systemic}
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,
        ];
      },
    },
    {
      field: "transactionType",
      headerName: "نوع",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      minWidth: 100,
      type: "singleSelect",
      valueOptions: ListofTransactionType,
    },

    {
      field: "customerRef",
      headerName: "مشتری",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 160,
      type: "singleSelect",
      valueOptions: getCustomers,
    },
    {
      field: "transactionDate",
      headerName: "تاریخ",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,

      minWidth: 200,
      renderEditCell: renderDateEditInputCell,
      renderCell: renderDate,
    },
    {
      field: "docNumber",
      headerName: "شماره سند",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 150,
    },
    {
      field: "description",
      headerName: "شرح",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 250,
    },
    {
      field: "caseNumber",
      headerName: "شماره پرونده",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 250,
    },

    {
      field: "amount",
      headerName: "مبلغ",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 100,
      renderCell: (params: GridRenderCellParams<any, string>) => {
        return (
          params.value?.toLocaleString() + (params.row?.isDebit ? "+" : "-")
        );
      },
    },
    {
      field: "isDebit",
      headerName: "بدهکار",
      align: "left",
      type: "boolean",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 50,
    },
  ];

  const columnsUser: GridColDef[] = [
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={
                  <SaveIcon
                    color={
                      params.row.transactionType !== TransactionType.Manual
                        ? "disabled"
                        : "success"
                    }
                  />
                }
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                disabled={params.row.transactionType !== TransactionType.Manual}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }

        return [
          <BootstrapTooltip title="ویرایش">
            <GridActionsCellItem
              icon={
                <EditIcon
                  color={
                    params.row.transactionType !== TransactionType.Manual
                      ? "disabled"
                      : "primary"
                  }
                />
              }
              label="ویرایش"
              disabled={params.row.transactionType !== TransactionType.Manual}
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={
                <DeleteIcon
                  color={
                    params.row.transactionType === TransactionType.Systemic
                      ? "disabled"
                      : "error"
                  }
                />
              }
              label="حذف"
              disabled={params.row.transactionType === TransactionType.Systemic}
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,
        ];
      },
    },
    {
      field: "transactionType",
      headerName: "نوع",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      minWidth: 100,
      type: "singleSelect",
      valueOptions: ListofTransactionType,
    },

    {
      field: "transactionDate",
      headerName: "تاریخ",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,

      minWidth: 200,
      renderEditCell: renderDateEditInputCell,
      renderCell: renderDate,
    },
    {
      field: "docNumber",
      headerName: "شماره سند",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 150,
    },
    {
      field: "description",
      headerName: "شرح",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 250,
    },
    {
      field: "amount",
      headerName: "مبلغ",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 100,

      renderCell: (params: GridRenderCellParams<any, string>) => {
        return (
          params.value?.toLocaleString() + (params.row?.isDebit ? "+" : "-")
        );
      },
    },
    {
      field: "balance",
      headerName: "مانده",
      align: "center",
      headerAlign: "center",
      editable: false, // این ستون قابل ویرایش نیست
      sortable: false, // مرتب‌سازی نداره چون وابسته به ترتیب ردیف‌هاست
      minWidth: 120,
      renderCell: (params: GridRenderCellParams<any, any>) => {
        const rows = params.api.getRowModels(); // گرفتن همه ردیف‌ها
        const currentIndex = params.api.getRowIndexRelativeToVisibleRows(
          params.id
        ); // اندیس ردیف فعلی
        const previousRows = Array.from(rows.values()).slice(
          0,
          currentIndex + 1
        ); // ردیف‌ها تا این ردیف

        const balance = previousRows.reduce((sum, row) => {
          const amount = row.amount || 0;
          return row.isDebit ? sum + amount : sum - amount;
        }, 0);

        return balance.toLocaleString(); // نمایش با جداکننده هزارگان
      },
    },
  ];
  const [bankId, setBankId] = useState("");

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setBankId(id);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    let deleteSuccess = false;
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });

        // حذف ردیف از لیست محلی
        setRows((prevRows) =>
          prevRows.filter((row) => row.id?.toString() !== bankId)
        );
        deleteSuccess = true;
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      // فقط در صورت خطا، داده‌ها را مجدداً از سرور دریافت کن
      if (!deleteSuccess) {
        if (pathName === location.pathname) {
          getTransactions();
        } else if (userId) {
          getTransactionsByUserId(userId);
        }
      }
      handleDeletePopoverClose();
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenTask(true)}
        >
          تراکنش جدید
        </Button>

        <ImportExcelButton
          notify={notifications}
          refetch={
            pathName === location.pathname
              ? getTransactions
              : () => getTransactionsByUserId(userId ?? "")
          }
        />
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow: ITransaction = {
      ...newRow,
      isNew: false,
      transactionDate: ConvertToMiladiDateDB(newRow.transactionDate),
    };
    let res;
    if (newRow.transactionType !== TransactionType.Manual) {
      res = await updateAsync({
        ...rows.find((r) => r.id === updatedRow.id),
        docNumber: updatedRow.docNumber,
      });
    } else {
      res = await updateAsync(updatedRow);
    }
    if (res.status) {
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );

      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      // فقط در صورت خطا، داده‌ها را مجدداً از سرور دریافت کن
      if (pathName === location.pathname) {
        getTransactions();
      } else if (userId) {
        getTransactionsByUserId(userId);
      }
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };
  const handleClose = () => {
    setOpenTask(false);
  };

  return (
    <>
      <PageTitle title="تراکنش‌ها" />
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />

      <NewTransaction
        open={openTask}
        handleClose={handleClose}
        refetch={
          pathName === location.pathname
            ? getTransactions
            : () => getTransactionsByUserId(userId ?? "")
        }
        customerRef={userId}
        // data={rowInfo}
      />

      <Box>
        {(isTransactionLoading ||
          isEditLoading ||
          isDeleteLoading ||
          isTransactionByUserIdLoading) && <LinearProgress />}

        <GridViewMUIX
          columns={location.pathname === pathName ? columns : columnsUser}
          loading={isTransactionLoading || isEditLoading}
          EditToolbar={EditToolbar}
          rowModesModel={rowModesModel}
          sortFields={{
            field: "transactionDate",
            sort: location.pathname === pathName ? "desc" : "asc",
          }}
          processRowUpdate={processRowUpdate}
          rows={rows
            .sort((a, b) => {
              const dateA = moment(a.transactionDate, "jYYYY/jMM/jDD");
              const dateB = moment(b.transactionDate, "jYYYY/jMM/jDD");
              return dateA.valueOf() - dateB.valueOf(); // مرتب‌سازی نزولی
            })
            .map((row) => ({
              ...row,
              caseNumber: row.customer?.caseNumber ?? "-",
            }))}
          setRowModesModel={setRowModesModel}
          gridUniqueName="transactions"
        />
      </Box>
    </>
  );
};

export default Transactions;
